import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react'

import { LightModeModalContent } from '../Modal/LightModeModalContent'

export type DeleteModalProps = Omit<ModalProps, 'children'> & {
  onConfirm?: () => void
}

export const DeleteModal = ({ onConfirm, ...props }: DeleteModalProps) => {
  return (
    <Modal size="lg" {...props}>
      <ModalOverlay />
      <LightModeModalContent>
        <ModalHeader>Delete View</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text
            display="flex"
            alignItems="center"
            height="30px"
            fontFamily="Montserrat"
            fontStyle="normal"
            fontWeight="500"
            fontSize="12px"
            lineHeight="140%"
            letterSpacing=".2px"
            color="presets.turquoise.100"
            mt={54}
          >
            Are you sure you want to delete this saved view? You will not be
            able to recover it after the delete action.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            color="presets.turquoise.100"
            variant="simple"
            onClick={props.onClose}
          >
            Cancel
          </Button>
          <Button
            variant="dangerButton"
            padding="5px 15px"
            width="114px"
            height="40px"
            fontSize="14px"
            lineHeight="140%"
            letterSpacing="0.2px"
            mr={1}
            ml={4}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </ModalFooter>
      </LightModeModalContent>
    </Modal>
  )
}
